/**
 * Celery / Step Function–style pipeline phases (backend + document.processing webhooks).
 * Uppercase strings match backend `get_execution_status` and worker webhooks.
 */
export const DOCUMENT_PROCESSING_PIPELINE_PHASES = [
	'QUEUED',
	'RUNNING',
	'INDEXING',
	'SUCCEEDED',
	'FAILED',
	'REVOKED',
	'UNKNOWN',
	'PROCESSING',
] as const

export type DocumentProcessingPipelinePhase = (typeof DOCUMENT_PROCESSING_PIPELINE_PHASES)[number]

/** i18n keys under `pages.projectDetail.artifactStatus` */
export const DOCUMENT_PIPELINE_PHASE_I18N_KEY: Record<DocumentProcessingPipelinePhase, string> = {
	QUEUED: 'pages.projectDetail.artifactStatus.pipelineQueued',
	RUNNING: 'pages.projectDetail.artifactStatus.pipelineRunning',
	INDEXING: 'pages.projectDetail.artifactStatus.pipelineIndexing',
	SUCCEEDED: 'pages.projectDetail.artifactStatus.pipelineSucceeded',
	FAILED: 'pages.projectDetail.artifactStatus.pipelineFailed',
	REVOKED: 'pages.projectDetail.artifactStatus.pipelineRevoked',
	UNKNOWN: 'pages.projectDetail.artifactStatus.pipelineUnknown',
	PROCESSING: 'pages.projectDetail.artifactStatus.pipelineProcessing',
}

const PHASE_SET = new Set<string>(DOCUMENT_PROCESSING_PIPELINE_PHASES)

export function parseDocumentProcessingPipelinePhase(
	raw: string | null | undefined
): DocumentProcessingPipelinePhase | undefined {
	if (raw == null || raw === '') return undefined
	const upper = String(raw).trim().toUpperCase()
	if (PHASE_SET.has(upper)) {
		return upper as DocumentProcessingPipelinePhase
	}
	return 'UNKNOWN'
}
